import { ptBR } from "@mui/material/locale";

/**
 * Extensão de tema MUI (textos de componentes: Autocomplete, TablePagination, etc.)
 * alinhada ao idioma do i18n. Português → ptBR; inglês/outros → padrão em inglês do MUI.
 */
export function getMuiLocaleExtension(i18nLanguage) {
  if (!i18nLanguage || typeof i18nLanguage !== "string") return {};
  const lang = i18nLanguage.split("-")[0].toLowerCase();
  if (lang === "pt") return ptBR;
  return {};
}
